import { ViolationDetails } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLW070007_01,
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
  },
  {
    title: "解除年月日",
    keyword: "cancelDate",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    requiredIcon: true,
  },
  {
    title: "共済法令違反内容",
    keyword: "lawsViolationDetail",
    type: "selectForm",
    selectPropsList: TkGetCodeList(ViolationDetails),
    requiredIcon: true,
  },
];

const headList: any[] = [
  {
    headTitle: "決裁日",
    align: "left",
  },
  {
    headTitle: "記号番号",
    align: "left",
  },
];

const schema = {
  cancelDate: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  lawsViolationDetail: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export { fakeTableList, headList, schema };
